export const ItemTypes = {
  FirstBase: 'firstBase',
  SecondBase: 'secondBase',
  ThirdBase: 'thirdBase',
  Remove: 'remove',
};
